// images a single comment or a new task can carry
export const MAX_ATTACHED_IMAGES = 6;
export const MAX_IMAGES_ALERT_ID = 'max_images_reached';

/**
 * RULES CONSTANT
 */
export const RULES_BUTTON = ['secondary', 'primary'];
/* Group MOVE */
export const GROUP_MOVE_NAME = 'move';
export const EVENT__MOVE = 'MOVE'; // Move to <Stage>
export const GROUP__MOVE = [EVENT__MOVE];
/* END Group MOVE */

/* Group AUTOCLICK */
export const GROUP_AUTOCLICK_NAME = 'autoclick';
export const EVENT__AUTOCLICK = 'AUTOCLICK'; // AUTO CLICK AFTER ** seconds
export const GROUP__AUTOCLICK = [EVENT__AUTOCLICK];
/* END Group AUTOCLICK */

/* Group assign */
export const GROUP_ASSIGN_NAME = 'assign';
export const EVENT__UNASSIGN = 'UNASSIGN'; // Unassign
export const EVENT__ASSIGN = 'ASSIGN'; // ASSIGN MEMBER
export const EVENT__ASSIGN_IF_NOTASSIGNED = 'ASSIGN_IF_NOTASSIGNED'; // Assign if not assigned
export const EVENT__ASSIGN_MENTION = 'ASSIGN_MENTION'; // Assign if not assigned
export const GROUP__ASSIGN = [
  EVENT__UNASSIGN,
  EVENT__ASSIGN,
  EVENT__ASSIGN_IF_NOTASSIGNED,
  EVENT__ASSIGN_MENTION,
];
/* END Group assign */
export const EXISTING__GROUPS = [GROUP__MOVE, GROUP__AUTOCLICK, GROUP__ASSIGN];

export const OTHER_STAGES = [
  {
    name: 'Previous stage',
    id: 'prev_stage',
  },
  {
    name: 'Next stage',
    id: 'next_stage',
  },
];
/**
 * END RULES CONSTANT
 */


export const noProposeTracking = 'noProposeTracking';

export default {};
